/**
 * This app's binding of the portable real-link module (`realLink.tsx`) to react-router: a plain click
 * navigates in-page, everything else (new tab, new window, middle-click) is the browser's. Use these, never
 * a `navigate()` in an onClick: `scripts/real-links-sweep.test.mjs` refuses one.
 */
import { RealLink, RowLink as PortableRowLink, type RealLinkProps, type RowLinkProps } from './realLink';

import { useRouterNavigate } from './useEntityLinkProps';

export { ROW_LINK_HOST } from './realLink';

/** A real link to an in-app route: names, cards, chips, notification and "go to" menu items. */
export function EntityLink(props: Omit<RealLinkProps, 'navigate'>) {
  return <RealLink {...props} navigate={useRouterNavigate()} />;
}

/** A real link stretched over its table row (put `ROW_LINK_HOST` on the row). */
export function RowLink(props: Omit<RowLinkProps, 'navigate'>) {
  return <PortableRowLink {...props} navigate={useRouterNavigate()} />;
}
